import { StarsMismatchTransferCtrl } from './stars-mismatch-transfer.controller';

export const StarsMismatchStepTransferComponent = {
  controller: StarsMismatchTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./stars-mismatch-transfer.html'),
};
